import { customerPortal } from "@vilocnv/allsetra-core";
import { ActionReducerMapBuilder } from "@reduxjs/toolkit";
import { getGeozoneObjectsAction } from "../actions/get-geozone-objects.action";
import { mapObjectsToMarkers } from "domain/objects/entities/mappers/map-objects-to-markers.mapper";

type GeozonesState = customerPortal.geozones.GeozonesState;

const getGeozoneObjectsCases = (
  builder: ActionReducerMapBuilder<GeozonesState>
) => {
  builder.addCase(getGeozoneObjectsAction.pending, (state) => {
    state.isLoadingGeozoneObjects = true;
  });
  builder.addCase(getGeozoneObjectsAction.fulfilled, (state, action) => {
    state.geozoneObjects = action.payload;
    state.geozoneObjectsMarkers = mapObjectsToMarkers(action.payload);
    state.isLoadingGeozoneObjects = false;
  });
  builder.addCase(getGeozoneObjectsAction.rejected, (state) => {
    state.isLoadingGeozoneObjects = false;
  });
};

export default getGeozoneObjectsCases;
